export enum FulfilmentStatus {
    LINKED = "LINKED",
    PENDING = "PENDING",
    COMPLETED = "COMPLETED",
    CLOSED = "CLOSED",
}
